import { render } from "./SubCategorySelector.vue?vue&type=template&id=155f13e6"
import script from "./SubCategorySelector.vue?vue&type=script&lang=js"
export * from "./SubCategorySelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__